import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	row: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	label: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	helpText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	timeTrigger: {
		maxWidth: 200,
	},
	// Wider than timeTrigger: "Morning of the meeting day" truncates under the 200px used for hour labels.
	deliveryTrigger: {
		maxWidth: 280,
	},
	statusLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	footer: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
});
